<template>
<div>
  <Loading :loading="this.loading"></Loading>
  <div v-show="!this.loading" class="content-wrapper" v-bind:class="{ modal_open: modalActive }">
    <div class="container">
      <article>

        <section class="section white-panel pt24 pr0 pl0 pb0 mb2p">
          <fieldset class="radio-disc left charge">
            <h2 class="fs18 font-weight-bold mb4">チャージ金額</h2>
            <table class="table w100p fs14">
              <tbody>
              <template v-for="(item, i) in this.chargeMenuList" :key="'menu-key-' + i">
                <tr>
                  <td class="bdb-solid-gray1 td-radio-left">
                    <label class="w100p">
                      <input class="radio-input" name="radio1" type="radio" v-model="selectedChargeValue" v-bind:value="item.charge_value" v-on:change="onChangeChargeMenu($event.target.value)">
                      <div class="label-name">
                        <span class="fs16 w100p font-weight-bold">チャージ金額：{{$filters.addComma(item.charge_value)}}円分</span>
                        <span class="fs14 w100p pl12">お支払金額：<span class="color-red2">{{$filters.addComma(item.default_payment)}}円</span></span>
                      </div>
                    </label>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </fieldset>
        </section>

        <section v-if="this.carwashCoupon.length" class="section white-panel mb2p switch-ui pt24">
          <h2 class="fs18 font-weight-bold mb20">今回使用するクーポン</h2>
          <div class="switch">
            <label class="switch__label">
              <input type="checkbox" class="switch__input" v-model="useCarwashCoupon"/>
              <span class="switch__content"></span>
              <span class="switch__circle"></span>
            </label>
          </div>
          <ul class="coupon-charge">
            <template v-for="(item, i) in this.carwashCouponList" :key="'coupon-key-'+i">
              <!-- クーポンの選択/未選択の切り替えは、li.class に active を設定 -->
              <li v-bind:class="{ active: item.isSelectedCoupon }">
              <!-- クーポンの選択/未選択の切り替えは、img src を変更 -->
              <p v-if="item.isSelectedCoupon" class="icon"><img src="/lib/images/ic_coupon.svg" width="39" height="39"></p>
              <p v-if="!item.isSelectedCoupon" class="icon"><img src="/lib/images/ic_coupon_off.svg" width="39" height="39"></p>
              <p class="detail"><strong class="fs14">{{item.name}}</strong><br>
              {{item.description}}<br>
              {{item.shortDescription}}</p>
              </li>
            </template>
          </ul>
        </section>

        <section class="section white-panel mb2p pt20 pr16 pb28 pl16">
          <h2 class="fs16 mt4 mb8">ご利用可能店舗</h2>
          <table class="table w100p fs14 line-height1_2">
            <tbody>
              <tr>
                <th class="font-weight-normal color-font2 va-top pt8 w20p">対象SS</th>
                <td class="va-top pt8 pl8 fs14 text-right">{{this.ssInfo.ss_name}}</td>
              </tr>
              <tr>
                <th class="font-weight-normal color-font2 va-top pt16"></th>
                <td class="va-top pt16 pl8 fs12 text-right">{{this.carwashType}}  対応店舗</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section class="section white-panel mb2p pt20 pr16 pb28 pl16">
          <table class="table w100p fs14 line-height1_2">
            <div>
              <p class="mb15 fs14">【サービス提供元】<br>コスモ石油マーケティング株式会社<br>東京都中央区京橋１－７－１<br>代表者：髙山 直樹</p>
            </div>
            <div>
              <p class="mb0 fs14">【連絡先】<br>０１２０－５３０３７２<br>２４時間年中無休<br></p>
            </div>
          </table>
        </section>

        <section class="section white-panel mb2p">
          <h2 class="fs18 font-weight-bold mb8">お申込み内容</h2>
          <table class="table w100p fs12 line-height1_7">
            <tbody>
              <tr>
                <td class="pt4 pb8 fs14">チャージする残高</td>
                <td class="pt4 pb8 pr4 text-right fs14">{{this.selectedChargeValue ? $filters.addComma(this.selectedChargeValue) : ''}}円</td>
              </tr>
              <tr v-if="this.useCarwashCoupon && this.getSaleValueBySelectedCoupon">
                <td class="bdb-solid-gray1 pt4 pb8 fs14">クーポン割引金額</td>
                <td class="bdb-solid-gray1 pt4 pb8 pr4 text-right fs14">-{{$filters.addComma(this.getSaleValueBySelectedCoupon)}}円</td>
              </tr>
              <tr>
                <td class="bdt-solid-gray1 pt8 pb4 font-weight-bold fs14">お支払い金額</td>
                <td class="bdt-solid-gray1 pt8 pb4 pr4 text-right font-weight-bold fs14">{{$filters.addComma(this.getAmountBySelectedMenu)}}円</td>
              </tr>
            </tbody>
          </table>
          <div class="bg-gray1 pd12 mt20 mb20">
            <p class="mb0 fs14">【ご注意事項】<br>
・残高の有効期限はチャージから180日です<br>
・上記ご利用店舗でのみ使えます<br>
・払い戻しはできません</p>
          </div>
          <button class="button fs16 mt8 mb4 pd16 radius200" v-bind:disabled="processing" v-on:click="modalOpen()">決済に進む</button>
        </section>

      </article>
    </div>
    <div class="modal_overlay">
      <div class="modal_container">
        <div class="modal_body radius8 pd28 mt8p mb8p">
          <h2 class="fs18 mb20 text-center">最終確認</h2>
          <div class="mt8 mb20">
            <span class="fs14 line-height1_6">ご利用店舗<br>{{this.ssInfo.ss_name}}</span>
          </div>
          <div class="flex bdb-solid-gray1">
            <span class="fs14 line-height1_6 inline-block" style="margin-right:auto">チャージする残高</span>
            <span class="fs14 line-height1_6 inline-block" style="margin-left:auto">{{this.selectedChargeValue ? $filters.addComma(this.selectedChargeValue) : ''}}円</span>
          </div>
          <div class="flex">
            <span class="fs14 line-height1_6 font-weight-bold inline-block" style="margin-right:auto">お支払い金額</span>
            <span class="fs14 line-height1_6 font-weight-bold inline-block" style="margin-left:auto">{{$filters.addComma(this.getAmountBySelectedMenu)}}円</span>
          </div>
          <div class="bg-gray1 pd12 mt20 mb20">
            <p class="mb0 fs14">【ご注意事項】<br>
・お支払いはクレジットカードのみとなります。<br>
・ご購入時に決済させて頂きます。<br>
・ご請求時期は各カード会社により異なります。<br>
・決済手続き完了時の引き渡しとなります。<br>
・通信状況により数分程度の遅延が生じることがあります。<br>
・商品の性質上、払い戻し・他店舗へのチャージ残高の付け替えはできません。<br>
・上記ご利用店舗でのみ使えます。<br>
・残高の有効期限はチャージから180日です。
            </p>
          </div>
          <button class="button fs16 w100p mb12 mb0 pd16 radius200" v-bind:disabled="processing" v-on:click="doCharge()">上記に同意してチャージを申込む<br>(決済に進む)</button>
          <button class="button button-gray fs16 w100p mb12 mb0 pd16 radius200" v-on:click="modalClose()">キャンセル</button>
        </div>
      </div>
    </div>
    <!-- ネイティブからJSを実行して洗車TOPへ戻るために、クエリパラメータを格納する。 -->
    <input id="tsid" type="hidden" name="tsid" v-bind:value="nativeData.tsid">
    <input id="otoken" type="hidden" name="otoken" v-bind:value="nativeData.otoken">
    <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="nativeData.popinfoid">
    <input id="authid" type="hidden" name="authid" v-bind:value="nativeData.authid">
    <input id="ss_code" type="hidden" name="ss_code" v-bind:value="nativeData.ss_code">
    <input id="x_cls_app_version" type="hidden" name="x_cls_app_version" v-bind:value="nativeData.x_cls_app_version">
    <input id="x_cls_os" type="hidden" name="x_cls_os" v-bind:value="nativeData.x_cls_os">
    <input id="x_cls_os_version" type="hidden" name="x_cls_os_version" v-bind:value="nativeData.x_cls_os_version">
    <input id="dpi" type="hidden" name="dpi" v-bind:value="this.$route.query.dpi">
    <input id="device_pixel_ratio" type="hidden" name="device_pixel_ratio" v-bind:value="this.$route.query.device_pixel_ratio">
  </div>
  <iframe v-if="iframeHtml" ref="iframe" :srcdoc="iframeHtml" @load="extractHtml" style="width: 0px; height: 0px; display: none;"></iframe>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import chargeMenuApi from '@/store/Api/chargeMenu'
import carwashCouponApi from '@/store/Api/carwashCoupon'
import prepaidCardApi from '@/store/Api/prepaidCard'
import prepaidCardNormalTrialChargeApi from '@/store/Api/prepaidCardNormalTrialCharge'
import gmoLinkTypePlusPaymentApi from '@/store/Api/gmoLinkTypePlusPayment'
import ssApi from '@/store/Api/ss'
import Loading from '@/views/v2/Loading'
import modal from '@/assets/v2/modal'
import config from '@/commons/v2/config'
import { useGmoPageStore } from '@/store/gmoPage'

export default {
  data () {
    return {
      loading: true,
      processing: false,
      ssInfo: [],
      createdPrepaidCard: {
        card_no: null,
        pin_cd: null
      },
      // メニューで選択中のチャージバリュー
      selectedChargeValue: null,
      // クーポン利用の有無
      useCarwashCoupon: false,
      // 最終確認モーダル
      modalActive: false,
      iframeHtml: null
    }
  },
  methods: {
    ...mapActions('CHARGE_MENU', [
      'setChargeMenu'
    ]),
    ...mapActions('CARWASH_COUPON', [
      'setCarwashCoupon'
    ]),
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    setCreatedPrepaidCard (prepaidCard) {
      this.createdPrepaidCard = prepaidCard
    },
    // 画面表示時のチャージメニュー初期選択
    initSelectionChargeMenu () {
      if (this.chargeMenuList) {
        this.selectedChargeValue = this.chargeMenuList[0].charge_value
        // チャージメニュー初期選択と同時にクーポンも選択させる
        this.onChangeChargeMenu(this.selectedChargeValue)
      }
    },
    // 選択されたメニューに該当するクーポンを選択
    onChangeChargeMenu (chargeValue) {
      this.carwashCoupon.forEach(coupon => {
        // クーポンの選択/未選択フラグ
        coupon.isSelectedCoupon = coupon.chargeValue === chargeValue.toString()
      })
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    // 決済へ進むボタンタップ
    modalOpen () {
      this.nativeEVENTSet('CarWashChargeButton', 'MODAL_OPEN', 'TAP')
      window.modalHeight = window.pageYOffset
      window.scrollTo(0, 0)
      this.modalActive = true
    },
    // モーダル内のキャンセルボタンタップ
    modalClose () {
      this.nativeEVENTSet('CarWashChargeButton', 'MODAL_CLOSE', 'TAP')
      window.scrollTo(0, window.modalHeight)
      this.modalActive = false
    },
    // モーダル内の決済へ進むボタンタップ
    async doCharge () {
      // [eventTrack]
      const couponUuid = this.getSelectedCoupon ? this.getSelectedCoupon.uuid : null
      this.nativeEVENTSet('CarWashChargeButton', 'MOVED_KESSAI', 'TAP', { chargeValue: String(this.selectedChargeValue), CouponUuid: couponUuid })

      if (this.cardExists) {
        // カードが存在する場合の決済プロセス
        this.doChargeForCardExists()
      } else {
        // カードが存在しない場合の決済プロセス
        this.doChargeForCardNotExists()
      }
    },
    /**
     * カード発行済みの場合の決済処理
    */
    async doChargeForCardExists () {
      // 二度押しロック
      this.processing = true
      let isApiError = false

      // カードが存在するので、通常バリューチャージ(試算)
      const postData = {
        // クエリパラメータから取得
        card_no: this.nativeData.card_no,
        // クエリパラメータから取得
        pin_cd: this.nativeData.pin_cd,
        // 選択中のチャージバリュー
        charge_value_amount: this.selectedChargeValue
      }

      console.log('*** prepaidCardNormalTrialChargeApiPost-requestParam ***')
      console.log(postData)

      await prepaidCardNormalTrialChargeApi.post(
        this.nativeData.authid,
        this.nativeData.ss_code,
        postData
      ).then(res => { // eslint-disable-line no-unused-vars
      }).catch(e => { // eslint-disable-line no-unused-vars
        console.log('prepaidCardNormalTrialChargeApiPost-error')
        // バリューチャージ上限値を超える場合は個別でエラーメッセージを出力させる
        if (!isApiError && e.response.data.message.result_cd === config.VALUE_CHARGE_EXCEED_LIMIT_ERROR_RESPONSE) {
          this.openErrorModal(e.response.data.message.message)
          isApiError = true
        } else if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
        // 二度押しロック解除
        this.processing = false
      })

      if (!isApiError) {
        const postData = {
          tsid: this.nativeData.tsid,
          popinfo_id: this.nativeData.popinfoid,
          otoken: this.nativeData.otoken,
          ss_code: this.nativeData.ss_code,
          carwash_coupon_uuid: this.getSelectedCoupon ? this.getSelectedCoupon.uuid : null,
          carwash_coupon_price: this.getSelectedCoupon ? this.getSelectedCoupon.saleValue : null,
          card_no: this.nativeData.card_no,
          pin_cd: this.nativeData.pin_cd,
          // お支払い金額（精算金額）：GMOにて実際に支払う金額
          amount: this.getAmountBySelectedMenu,
          // 選択中のチャージバリュー
          value: this.selectedChargeValue,
          // 選択中のメニューの割引額()
          default_discount_price: this.getDefaultDiscountPriceBySelectedMenu,
          // 洗車クーポン発行元（原資負担）
          bear: this.getSelectedCoupon ? this.getSelectedCoupon.bearer : null
        }

        console.log('*** gmoLinkTypePlusApiPost-requestParam ***')
        console.log(postData)

        await gmoLinkTypePlusPaymentApi.post(
          this.nativeData.authid,
          postData
        ).then(res => {
          const gmoUrl = res.data
          // 戻るボタンの出し分け
          this.appDisplayBack(false)
          // GMO決済画面
          const gmoPageStore = useGmoPageStore()
          gmoPageStore.gmoUrl = gmoUrl
          this.$router.push({
            name: 'V2Settlement',
            query: {
              tsid: this.nativeData.tsid,
              popinfoid: this.nativeData.popinfoid,
              otoken: this.nativeData.otoken,
              authid: this.nativeData.authid,
              ss_code: this.nativeData.ss_code,
              card_no: this.nativeData.card_no,
              pin_cd: this.nativeData.pin_cd,
              x_cls_app_version: this.nativeData.x_cls_app_version,
              x_cls_os: this.nativeData.x_cls_os,
              x_cls_os_version: this.nativeData.x_cls_os_version,
              dpi: this.nativeData.dpi,
              device_pixel_ratio: this.nativeData.device_pixel_ratio
            }
          })
        }).catch(e => { // eslint-disable-line no-unused-vars
          console.log('gmoLinkTypeGetApiPost-error')
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
          // 二度押しロック解除
          this.processing = false
        })
      }
    },
    /**
     * カード未発行の場合の決済処理
    */
    async doChargeForCardNotExists () {
      // 二度押しロック
      this.processing = true
      let isApiError = false

      // カードが存在しないので、プリペイドカード新規発行
      try {
        const res = await prepaidCardApi.post(this.nativeData.authid, this.nativeData.ss_code)
        this.setCreatedPrepaidCard(res.data.body)
      } catch (e) {
        console.log('prepaidCardApiPost-error')
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
        this.processing = false
      }

      if (!isApiError) {
        // 発行したプリペイドカードで通常バリューチャージ(試算)
        const postData = {
          // 発行したプリペイドカード
          card_no: this.createdPrepaidCard.card_no,
          pin_cd: this.createdPrepaidCard.pin_cd,
          // 選択中のチャージバリュー
          charge_value_amount: this.selectedChargeValue
        }

        console.log('*** prepaidCardNormalTrialChargeApiPost-requestParam ***')
        console.log(postData)

        await prepaidCardNormalTrialChargeApi.post(
          this.nativeData.authid,
          this.nativeData.ss_code,
          postData
        ).then(res => { // eslint-disable-line no-unused-vars
        }).catch(e => { // eslint-disable-line no-unused-vars
          console.log('prepaidCardNormalTrialChargeApiPost-error')
          // バリューチャージ上限値を超える場合は個別でエラーメッセージを出力させる
          if (!isApiError && e.response.data.message.result_cd === config.VALUE_CHARGE_EXCEED_LIMIT_ERROR_RESPONSE) {
            this.openErrorModal(e.response.data.message.message)
            isApiError = true
          } else if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
          // 二度押しロック解除
          this.processing = false
        })
      }

      if (!isApiError) {
        const postData = {
          tsid: this.nativeData.tsid,
          popinfo_id: this.nativeData.popinfoid,
          otoken: this.nativeData.otoken,
          ss_code: this.nativeData.ss_code,
          carwash_coupon_uuid: this.getSelectedCoupon ? this.getSelectedCoupon.uuid : null,
          carwash_coupon_price: this.getSelectedCoupon ? this.getSelectedCoupon.saleValue : null,
          // 発行したプリペイドカード
          card_no: this.createdPrepaidCard.card_no,
          pin_cd: this.createdPrepaidCard.pin_cd,
          // お支払い金額（精算金額）：GMOにて実際に支払う金額
          amount: this.getAmountBySelectedMenu,
          // 選択中のチャージバリュー
          value: this.selectedChargeValue,
          // 選択中のメニューの割引額()
          default_discount_price: this.getDefaultDiscountPriceBySelectedMenu,
          // 洗車クーポン発行元（原資負担）
          bear: this.getSelectedCoupon ? this.getSelectedCoupon.bearer : null
        }

        console.log('*** gmoLinkTypeGetApiPost-requestParam ***')
        console.log(postData)

        await gmoLinkTypePlusPaymentApi.post(
          this.nativeData.authid,
          postData
        ).then(res => {
          const gmoUrl = res.data
          // 戻るボタンの出し分け
          this.appDisplayBack(false)
          // GMO決済画面
          const gmoPageStore = useGmoPageStore()
          gmoPageStore.gmoUrl = gmoUrl
          this.$router.push({
            name: 'V2Settlement',
            query: {
              tsid: this.nativeData.tsid,
              popinfoid: this.nativeData.popinfoid,
              otoken: this.nativeData.otoken,
              authid: this.nativeData.authid,
              ss_code: this.nativeData.ss_code,
              card_no: this.nativeData.card_no,
              pin_cd: this.nativeData.pin_cd,
              x_cls_app_version: this.nativeData.x_cls_app_version,
              x_cls_os: this.nativeData.x_cls_os,
              x_cls_os_version: this.nativeData.x_cls_os_version,
              dpi: this.nativeData.dpi,
              device_pixel_ratio: this.nativeData.device_pixel_ratio
            }
          })
        }).catch(e => { // eslint-disable-line no-unused-vars
          console.log('gmoLinkTypeGetApiPost-error')
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
          // 二度押しロック解除
          this.processing = false
        })
      }
    }
  },
  computed: {
    ...mapGetters('CHARGE_MENU', [
      'chargeMenu'
    ]),
    ...mapGetters('CARWASH_COUPON', [
      'carwashCoupon'
    ]),
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したクエリパラメータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      getData.authid = this.$route.query.authid
      getData.ss_code = this.$route.query.ss_code
      getData.card_no = this.$route.query.card_no
      getData.pin_cd = this.$route.query.pin_cd
      getData.x_cls_app_version = this.$route.query.x_cls_app_version
      getData.x_cls_os = this.$route.query.x_cls_os
      getData.x_cls_os_version = this.$route.query.x_cls_os_version
      getData.dpi = this.$route.query.dpi
      getData.device_pixel_ratio = this.$route.query.device_pixel_ratio
      return getData
    },
    // 表示用チャージメニューリスト
    chargeMenuList: function () {
      const chargeMenuList = this.chargeMenu
      return chargeMenuList.sort(function (a, b) {
        return a.sort_number - b.sort_number
      })
    },
    // DT洗車タイプを表示
    carwashType: function () {
      const handWash = this.ssInfo.hand_carwash_flag ? '手洗い・機械洗車' : ''
      const driveThrough = this.ssInfo.dt_carwash_flag ? 'ドライブスルー' : ''
      // empty を除去してから読点でつなぐ
      return [handWash, driveThrough].filter(v => v).join('、')
    },
    // 表示用DT洗車クーポンリスト
    carwashCouponList: function () {
      const carwashCouponList = this.carwashCoupon
      return carwashCouponList.sort(function (a, b) {
        return a.chargeValue - b.chargeValue
      })
    },
    // 選択しているDT洗車クーポンを取得
    getSelectedCoupon: function () {
      if (!this.useCarwashCoupon) {
        // クーポン利用がチェックされていない
        return null
      }
      const coupon = this.carwashCoupon.find(function (coupon) {
        // 選択中かどうか
        return coupon.isSelectedCoupon
      })
      return coupon ?? null
    },
    // 選択しているチャージメニューを取得
    getSelectedMenu: function () {
      let selectedMenu = null
      this.chargeMenu.forEach(menu => {
        // 該当のチャージバリューのもの
        if (menu.charge_value === this.selectedChargeValue) {
          selectedMenu = menu
        }
      })
      return selectedMenu
    },
    // 選択しているチャージメニューのデフォルトの割引額を取得
    // TMNへのチャージ額(charge_value) から GMOへの支払額(default_payment) を引いたもの
    getDefaultDiscountPriceBySelectedMenu: function () {
      // 選択中のチャージメニュー
      const menu = this.getSelectedMenu
      return menu.charge_value - menu.default_payment
    },
    // 選択しているDT洗車クーポンの割引額
    getSaleValueBySelectedCoupon: function () {
      const coupon = this.carwashCoupon.find(function (coupon) {
        // 選択中かどうか
        return coupon.isSelectedCoupon
      })
      return coupon ? coupon.saleValue : ''
    },
    // お支払い金額（精算金額）
    // GMOにて実際に支払う金額
    getAmountBySelectedMenu: function () {
      let amount = 0
      if (this.selectedChargeValue && this.chargeMenu && this.carwashCoupon) {
        // 選択中のメニュー
        const selectedMenu = this.getSelectedMenu

        // 選択中のクーポン
        const coupon = this.carwashCoupon.find(function (coupon) {
          return coupon.isSelectedCoupon
        })

        // 精算金額
        amount = selectedMenu.default_payment
        if (this.useCarwashCoupon && coupon) {
          // 精算金額 = GMOへの支払額 - クーポン割引額
          amount = amount - coupon.saleValue
        }
      }
      return amount
    },
    cardExists: function () {
      return this.nativeData.card_no && this.nativeData.pin_cd
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    let isApiError = false

    // DT洗車チャージメニュー情報取得
    await chargeMenuApi.get().then(res => {
      this.setChargeMenu(res.data.charge_menu)
    }).catch(e => {
      console.log('charge-menu-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // DT洗車クーポン
    // デバイスタイプの連携方法に従来仕様と齟齬があったため、デバイスタイプをi(iOS)のみに修正
    // cf.https://gitlab.ssl.iridge.jp/cosmo-oil/carwash-front/-/issues/25
    const dtype = config.CARWASH_COUPON_API_DTYPE_IOS
    await carwashCouponApi.get(
      this.nativeData.ss_code,
      this.nativeData.popinfoid,
      this.nativeData.tsid,
      this.nativeData.otoken,
      dtype
    ).then(res => {
      this.setCarwashCoupon(res.data.body.carwash_coupon)
    }).catch(e => {
      console.log('carwash-coupon-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // SS
    await ssApi.get(this.nativeData.ss_code).then(res => {
      this.setSsInfo(res.data.body.ss_info)
    }).catch(e => {
      console.log('ss-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // 初期選択させる(チャージメニュー, クーポン)
    this.initSelectionChargeMenu()

    // クーポンが存在する場合は、クーポン使用/未使用フラグを使用するにしておく
    this.useCarwashCoupon = !!this.carwashCoupon.length

    // [eventTrack]
    this.nativePVset('CARWASH_CHARGE')

    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading
  }
}
</script>
